// extracted by mini-css-extract-plugin
export default {"editButton":"undoPayrollCalculation_editButton__QkpBY","TableBody":"undoPayrollCalculation_TableBody__ytcPz","StopButton":"undoPayrollCalculation_StopButton__DEX+s"};